/** @format */

import { Component, OnInit } from '@angular/core';

import { MyAccountService } from '@shared/data-access/services';

@Component({
	selector: 'scorecard-gold-member-status',
	templateUrl: './gold-member-status.component.html',
	styleUrls: ['./gold-member-status.component.scss'],
	standalone: false
})
export class GoldMemberStatusComponent implements OnInit {
	constructor(private myAccountService: MyAccountService) {}

	ngOnInit(): void {
		this.myAccountService.getPersonalInformationV3().subscribe();
	}
}
